// src/app/image-viewer/image-viewer.component.ts
import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'vdr-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent {
  currentIndex = 0

  constructor(
    public dialogRef: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { imageUrls: string[]; initialIndex: number; expandedPreview?: boolean }
  ) {
    this.currentIndex = data.initialIndex
  }

  get currentImageUrl(): string {
    return this.data.imageUrls[this.currentIndex]
  }

  nextImage(): void {
    if (this.currentIndex < this.data.imageUrls.length - 1) {
      this.currentIndex++
    }
  }

  previousImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--
    }
  }

  close(): void {
    this.dialogRef.close()
  }
}
